/*
 * Angel Ruche mystery-discount quiz (ESSENCE).
 *
 * Configured by snippets/ar-quiz.liquid through window.ARQuizConfig.
 * Funnel steps go to POST {endpoint}/track; the finished quiz goes to
 * POST {endpoint}/complete, which records the lead, subscribes the shopper in
 * Klaviyo (email, plus SMS when consented) and fires "Quiz Completed". The
 * discount itself is sent by the Klaviyo flow on that event - this popup
 * never shows a code.
 *
 * The SMS step only appears to shoppers in Angel Ruche's Klaviyo SMS sending
 * regions (COUNTRIES below); everyone else finishes on the email step.
 *
 * QA: add ?ar_quiz=1 to any storefront URL to open it immediately, ignoring
 * every suppression rule. ?ar_quiz_variant=desktop|mobile forces a layout.
 */
(function () {
  "use strict";

  if (window.AngelRucheQuiz) return;

  var RAW = window.ARQuizConfig || {};
  var ASSETS = RAW.assets || {};

  var IMG = {
    desktopLeft: ASSETS.hero,
    last: ASSETS.success,
    decoBow: ASSETS.bow,
    decoBag: ASSETS.bag,
    decoSkirt: ASSETS.skirt,
    logo: ASSETS.logo
  };

  var params = new URLSearchParams(location.search);
  var qVariant = params.get("ar_quiz_variant");

  var CFG = {
    endpoint: String(RAW.endpoint || "").replace(/\/+$/, ""),
    clientKey: RAW.clientKey || "angel-ruche",
    quizKey: RAW.quizKey || "",
    country: String(RAW.country || "").toUpperCase(),
    termsUrl: RAW.termsUrl || "/policies/terms-of-service",
    privacyUrl: RAW.privacyUrl || "/policies/privacy-policy",
    delayMs: Number(RAW.delayMs) >= 0 ? Number(RAW.delayMs) : 8000,
    exitIntentAfterMs: 4000,
    mobileScrollDepth: 0.5,
    dismissDays: Number(RAW.dismissDays) > 0 ? Number(RAW.dismissDays) : 14,
    suppress: RAW.suppress === true,
    mobileBreakpoint: 720,
    forceVariant: qVariant === "desktop" || qVariant === "mobile" ? qVariant : "auto"
  };

  var STORE = {
    submitted: "arQuiz:submitted",
    dismissedAt: "arQuiz:dismissedAt",
    seen: "arQuiz:seen"
  };

  var QUESTIONS = [
    {
      key: "style",
      headline: "Choose your mood...",
      options: [
        { label: "Bambi Baby", value: "bambi" },
        { label: "2000s y2k", value: "y2k" },
        { label: "Whimsy Polka", value: "polka" },
        { label: "Cozy-off duties", value: "cozy" },
        { label: "Preppy plaids", value: "plaid" }
      ]
    }
  ];

  // Mirrors `recommendations` for angel-ruche in the ESSENCE server's
  // services/quizClients.js. The server's collectionPath wins when it answers.
  var EDITS = {
    bambi: { name: "Bambi Baby", path: "/collections/my-true-form-collection" },
    y2k: { name: "2000s y2k", path: "/collections/pink-cable-matching-knit-sets" },
    polka: { name: "Whimsy Polka", path: "/collections/dolly-polka-dot-dress" },
    cozy: { name: "Cozy-off duties", path: "/collections/knit-collection" },
    plaid: { name: "Preppy plaids", path: "/collections/plaid-girl" }
  };

  function resolve(a) {
    var key = EDITS[a.style] ? a.style : "cozy";
    return { edit: key, path: EDITS[key].path };
  }

  var answers = {};
  var step = 0;
  var result = null;
  var lastFocus = null;
  var currentRender = null;
  var variant = "desktop";
  var scrim, modal, media, pane, bars;
  var anonId = newAnonId();
  var viewed = false;
  var submitted = false;
  var closedOut = false;

  // Angel Ruche's Klaviyo SMS sending regions: Klaviyo rejects any other
  // country outright. `mobile` is the national number after the trunk 0, so a
  // landline or typo is caught here instead of silently failing in Klaviyo.
  var COUNTRIES = [
    { iso: "GB", name: "United Kingdom", dial: "44", mobile: /^7\d{9}$/ },
    { iso: "FR", name: "France", dial: "33", mobile: /^[67]\d{8}$/ },
    { iso: "DE", name: "Germany", dial: "49", mobile: /^1[5-7]\d{8,9}$/ },
    { iso: "CH", name: "Switzerland", dial: "41", mobile: /^7[5-9]\d{7}$/ },
    { iso: "SE", name: "Sweden", dial: "46", mobile: /^7\d{8}$/ },
    { iso: "NO", name: "Norway", dial: "47", mobile: /^[49]\d{7}$/ },
    { iso: "DK", name: "Denmark", dial: "45", mobile: /^[2-9]\d{7}$/ },
    { iso: "IT", name: "Italy", dial: "39", mobile: /^3\d{8,9}$/ },
    { iso: "PT", name: "Portugal", dial: "351", mobile: /^9\d{8}$/ },
    { iso: "PL", name: "Poland", dial: "48", mobile: /^[4-8]\d{8}$/ },
    { iso: "LU", name: "Luxembourg", dial: "352", mobile: /^6\d{8}$/ }
  ];

  var COUNTRY_BY_ISO = {};
  for (var ci = 0; ci < COUNTRIES.length; ci++) {
    COUNTRIES[ci].flag = flagOf(COUNTRIES[ci].iso);
    COUNTRY_BY_ISO[COUNTRIES[ci].iso] = COUNTRIES[ci];
  }

  /** Regional-indicator pair, so this file stays ASCII whatever charset it is served with. */
  function flagOf(iso) {
    try {
      return String.fromCodePoint(0x1f1e6 + iso.charCodeAt(0) - 65, 0x1f1e6 + iso.charCodeAt(1) - 65);
    } catch (e) {
      return iso;
    }
  }

  function countryFromLocale() {
    try {
      var lang = (navigator.language || navigator.userLanguage || "").toUpperCase();
      var m = lang.match(/-([A-Z]{2})\b/);
      if (m && COUNTRY_BY_ISO[m[1]]) return m[1];
      if (lang.length === 2) {
        var map = { FR: "FR", DE: "DE", PT: "PT", IT: "IT", SV: "SE", DA: "DK", NB: "NO", NN: "NO", PL: "PL", LB: "LU" };
        if (map[lang] && COUNTRY_BY_ISO[map[lang]]) return map[lang];
      }
    } catch (e) {}
    return "";
  }

  // Shopify already knows the shopper's market; no third-party geo lookup.
  var shopperCountry = CFG.country || countryFromLocale();
  // Outside the SMS regions the text step is skipped: the quiz finishes on the
  // email step and never promises a text Klaviyo cannot send.
  var smsEligible = !!COUNTRY_BY_ISO[shopperCountry];
  var phoneCountry = smsEligible ? shopperCountry : COUNTRIES[0].iso;

  function getCountry(iso) {
    return COUNTRY_BY_ISO[iso] || COUNTRIES[0];
  }

  function parseStoredPhone(raw) {
    var out = { iso: phoneCountry, national: "" };
    if (!raw) return out;
    var s = String(raw).trim();
    if (s.charAt(0) === "+") {
      var digits = s.slice(1).replace(/\D/g, "");
      var best = null;
      for (var i = 0; i < COUNTRIES.length; i++) {
        var c = COUNTRIES[i];
        if (digits.indexOf(c.dial) === 0) {
          if (!best || c.dial.length > best.dial.length) best = c;
        }
      }
      if (best) {
        out.iso = best.iso;
        out.national = digits.slice(best.dial.length);
        return out;
      }
    }
    out.national = s.replace(/[^\d\s\-().]/g, "").replace(/^\+/, "");
    return out;
  }

  /**
   * E.164 for a mobile number in `iso`, or null. A pasted +<dial> prefix and
   * the national trunk 0 (UK 07..., FR 06...) are dropped; Italian mobiles
   * start with 3 and have no trunk 0.
   */
  function toE164(iso, input) {
    var c = getCountry(iso);
    var national = String(input || "").replace(/\D/g, "");
    if (/^\s*(\+|00)/.test(String(input || ""))) national = national.replace(/^0{0,2}/, "").replace(new RegExp("^" + c.dial), "");
    national = national.replace(/^0+/, "");
    return c.mobile.test(national) ? "+" + c.dial + national : null;
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  // ------------------------------------------------------------------
  // Storage - every access can throw (Safari private mode, blocked cookies).
  // ------------------------------------------------------------------

  function readStore(area, key) {
    try { return window[area].getItem(key); } catch (e) { return null; }
  }

  function writeStore(area, key, value) {
    try { window[area].setItem(key, value); } catch (e) {}
  }

  function newAnonId() {
    var id = "";
    try {
      var bytes = new Uint8Array(9);
      window.crypto.getRandomValues(bytes);
      for (var i = 0; i < bytes.length; i++) id += (bytes[i] % 36).toString(36);
    } catch (e) {
      id = Math.random().toString(36).slice(2, 11);
    }
    return "ar_" + Date.now().toString(36) + id;
  }

  // ------------------------------------------------------------------
  // Server + analytics
  // ------------------------------------------------------------------

  function post(path, body, keepalive) {
    var headers = { "Content-Type": "application/json" };
    if (CFG.quizKey) headers["X-Quiz-Key"] = CFG.quizKey;
    return fetch(CFG.endpoint + path, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
      credentials: "omit",
      keepalive: !!keepalive
    });
  }

  /** Anonymous funnel data only - no email or phone leaves through here. */
  function publish(name, extra) {
    var data = {
      quiz_variant: variant,
      last_step: step,
      recommendation: answers.style || null
    };
    if (extra) for (var k in extra) data[k] = extra[k];
    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: "ar_quiz_" + name };
      for (var d in data) dl["ar_quiz_" + d] = data[d];
      window.dataLayer.push(dl);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish("ar_quiz_" + name, data);
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent("ar-quiz:" + name, { detail: data }));
    } catch (e) {}
  }

  function track(event, keepalive) {
    publish(event);
    if (!CFG.endpoint) return;
    var body = {
      client_key: CFG.clientKey,
      event: event,
      anon_id: anonId,
      quiz_variant: variant,
      last_step: step
    };
    if (answers.style) body.recommendation = answers.style;
    try {
      post("/track", body, keepalive).catch(function () {});
    } catch (e) {}
  }

  function complete(keepalive) {
    submitted = true;
    var body = {
      client_key: CFG.clientKey,
      anon_id: anonId,
      recommendation: answers.style,
      email: answers.email,
      // The email step states the marketing opt-in next to its button.
      email_consent: true,
      quiz_variant: variant,
      last_step: step
    };
    if (answers.phone) {
      body.phone = answers.phone;
      body.sms_consent = true;
    }
    return post("/complete", body, keepalive).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.message || "Request failed");
          err.status = res.status;
          err.code = data.error;
          throw err;
        }
        return data;
      });
    });
  }

  /** Cookies this browser to the profile so Klaviyo's onsite tracking (viewed product, browse abandonment) attaches to it. */
  function identifyInKlaviyo(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === "function") {
        var p = window.klaviyo.identify({ email: email });
        if (p && typeof p.catch === "function") p.catch(function () {});
      } else {
        (window._learnq = window._learnq || []).push(["identify", { $email: email }]);
      }
    } catch (e) {}
  }

  // ------------------------------------------------------------------
  // Layout
  // ------------------------------------------------------------------

  function activeVariant() {
    if (CFG.forceVariant === "desktop" || CFG.forceVariant === "mobile") return CFG.forceVariant;
    return window.matchMedia("(max-width:" + (CFG.mobileBreakpoint - 1) + "px)").matches ? "mobile" : "desktop";
  }

  function paintMedia(src) {
    if (!media) return;
    media.setAttribute("aria-hidden", variant === "desktop" ? "false" : "true");
    var image = src || IMG.desktopLeft;
    if (media.getAttribute("data-ready") === image) return;
    media.setAttribute("data-ready", image);
    media.innerHTML = '<img src="' + esc(image) + '" alt="Angel Ruche">';
  }

  function mediaForStep() {
    if (step >= 4) return IMG.last;
    return IMG.desktopLeft;
  }

  function applyVariant(next) {
    var resolved = next || activeVariant();
    var changed = resolved !== variant;
    variant = resolved;
    if (!scrim) return;
    scrim.setAttribute("data-variant", variant);
    paintMedia(mediaForStep());
    if (changed && currentRender) currentRender();
    if (changed && variant === "mobile" && scrim && scrim.classList.contains("ar-open")) playDecos();
  }

  function build() {
    if (scrim) return;

    scrim = el("div");
    scrim.id = "ar-quiz-root";
    scrim.setAttribute("role", "dialog");
    scrim.setAttribute("aria-modal", "true");
    scrim.setAttribute("aria-label", "Find your Angel Ruche edit");

    modal = el("div", "ar-modal");
    media = el("div", "ar-modal__media");

    var body = el("div", "ar-modal__body");
    bars = null;

    pane = el("div", "ar-pane");

    body.appendChild(pane);
    var decos = el("div", "ar-decos");
    decos.setAttribute("aria-hidden", "true");
    decos.innerHTML =
      '<span class="ar-deco ar-deco--bow"><img src="' + esc(IMG.decoBow) + '" alt=""></span>' +
      '<span class="ar-deco ar-deco--bag"><img src="' + esc(IMG.decoBag) + '" alt=""></span>' +
      '<span class="ar-deco ar-deco--skirt"><img src="' + esc(IMG.decoSkirt) + '" alt=""></span>' +
      '<span class="ar-deco ar-deco--bow-br"><img src="' + esc(IMG.decoBow) + '" alt=""></span>';

    modal.appendChild(media);
    modal.appendChild(body);
    modal.appendChild(decos);
    scrim.appendChild(modal);
    document.body.appendChild(scrim);

    document.addEventListener("keydown", function (e) {
      if (!scrim.classList.contains("ar-open")) return;
      if (e.key === "Tab") trap(e);
    });

    window.addEventListener("resize", function () {
      if (CFG.forceVariant !== "auto") return;
      var next = activeVariant();
      if (next !== variant) applyVariant(next);
    });

    applyVariant();
  }

  function trap(e) {
    var nodes = modal.querySelectorAll("button, input, a[href]");
    var f = [];
    for (var i = 0; i < nodes.length; i++) {
      f.push(nodes[i]);
    }
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function paint(html, opts) {
    pane.innerHTML = '<div class="ar-pane__inner">' + html + "</div>";
    pane.scrollTop = 0;
    if (opts && opts.focusSelector) {
      var f = pane.querySelector(opts.focusSelector);
      if (f) f.focus({ preventScroll: true });
    }
  }

  function progress(n) {
    if (!bars) return;
    var kids = bars.children;
    for (var i = 0; i < kids.length; i++) kids[i].classList.toggle("ar-filled", i < n);
  }

  function busy(btn, on, label) {
    btn.disabled = on;
    btn.innerHTML = on ? '<span class="ar-spin"></span>' : label;
  }

  /**
   * Sends the finished quiz from whichever step the shopper is on. `ui` holds
   * that step's primary button (and its label), the buttons to lock while the
   * request runs, the error line and, on the SMS step, the phone input.
   */
  function submitQuiz(ui) {
    for (var i = 0; i < ui.lock.length; i++) ui.lock[i].disabled = true;
    busy(ui.next, true);

    complete(false).then(function (data) {
      if (data && typeof data.collectionPath === "string" && data.collectionPath.charAt(0) === "/") {
        result.path = data.collectionPath;
      }
      writeStore("localStorage", STORE.submitted, "1");
      identifyInKlaviyo(answers.email);
      publish("submitted", { sms_opt_in: !!answers.phone });
      renderSuccess();
    }).catch(function (e) {
      submitted = false;
      for (var j = 0; j < ui.lock.length; j++) ui.lock[j].disabled = false;
      busy(ui.next, false, ui.label);
      if (e && e.code === "invalid_email") {
        if (step === 2) {
          ui.err.textContent = "That email didn't work \u2014 check it and try again.";
        } else {
          renderEmail("That email didn't work \u2014 check it and try again.");
        }
        return;
      }
      if (e && e.code === "invalid_phone" && ui.input) {
        ui.err.textContent = "That number didn't work \u2014 check it and try again.";
        ui.input.focus();
        return;
      }
      ui.err.textContent = e && e.status === 429
        ? "Too many tries \u2014 give it a minute and try again."
        : "Something went wrong. Please try again.";
    });
  }

  // ------------------------------------------------------------------
  // Steps: 1 mood, 2 email, 3 SMS, 4 success
  // ------------------------------------------------------------------

  function renderQuestion(i) {
    currentRender = function () { renderQuestion(i); };
    step = i + 1;
    progress(i + 1);
    result = null;
    paintMedia(IMG.desktopLeft);
    var q = QUESTIONS[i];
    var fadeBase = i === 0 ? 3 : 2;
    var opts = q.options.map(function (o, idx) {
      return '<button type="button" class="ar-opt ar-fade ar-fade-' + Math.min(fadeBase + idx, 6) + '" data-v="' + o.value + '">' + o.label + "</button>";
    }).join("");

    var intro = "";
    if (i === 0) {
      intro =
        '<img class="ar-logo ar-fade ar-fade-1" src="' + esc(IMG.logo) + '" alt="Angel Ruche">' +
        '<h2 class="ar-h ar-h--gift ar-fade ar-fade-2">You\'ve Got a Mystery Discount</h2>' +
        '<p class="ar-sub ar-fade ar-fade-3">Choose your mood...</p>';
    } else {
      intro =
        '<h2 class="ar-h ar-fade ar-fade-1">' + q.headline + "</h2>";
    }

    paint(
      intro +
      '<div class="ar-opts" role="radiogroup" aria-label="Question">' + opts + "</div>" +
      '<p class="ar-dismiss ar-fade ar-fade-6"><button type="button" class="ar-textlink" data-act="dismiss">No thanks, I don\'t want a discount</button></p>'
    );

    Array.prototype.forEach.call(pane.querySelectorAll(".ar-opt"), function (b) {
      b.addEventListener("click", function () {
        answers[q.key] = b.getAttribute("data-v");
        result = resolve(answers);
        track("started");
        renderEmail();
      });
    });

    bindDismiss();
  }

  function bindDismiss() {
    var dismiss = pane.querySelector("[data-act=dismiss]");
    if (dismiss) dismiss.addEventListener("click", dismissQuiz);
  }

  function renderEmail(errorText) {
    currentRender = renderEmail;
    step = 2;
    progress(2);
    result = result || resolve(answers);
    paintMedia(IMG.desktopLeft);

    paint(
      '<h2 class="ar-h ar-fade ar-fade-2">Where should we send it?</h2>' +
      '<p class="ar-sub ar-fade ar-fade-3">Enter your email for your mystery discount.</p>' +
      '<div class="ar-field ar-fade ar-fade-4">' +
        '<label for="ar-email">Email</label>' +
        '<input id="ar-email" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com" value="' + esc(answers.email || "") + '">' +
      "</div>" +
      '<p class="ar-err" id="ar-err" role="alert">' + esc(errorText || "") + "</p>" +
      '<button type="button" class="ar-btn ar-wide ar-fade ar-fade-5" data-act="next">Continue</button>' +
      '<p class="ar-legal ar-fade ar-fade-5">By continuing, you agree to receive marketing emails from Angel Ruche. Unsubscribe anytime. <a href="' + esc(CFG.privacyUrl) + '" target="_blank" rel="noopener">Privacy Policy</a></p>' +
      '<p class="ar-dismiss ar-fade ar-fade-6"><button type="button" class="ar-textlink" data-act="dismiss">No thanks, I don\'t want a discount</button></p>',
      { focusSelector: "#ar-email" }
    );

    bindDismiss();

    var input = pane.querySelector("#ar-email");
    var err = pane.querySelector("#ar-err");
    var next = pane.querySelector("[data-act=next]");
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") next.click(); });
    input.addEventListener("input", function () { err.textContent = ""; });
    next.addEventListener("click", function () {
      var v = (input.value || "").trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) || v.length > 254) {
        err.textContent = "Enter a valid email to continue.";
        input.focus();
        return;
      }
      answers.email = v;
      if (!smsEligible) {
        delete answers.phone;
        submitQuiz({ next: next, label: "Continue", lock: [next, input], err: err });
        return;
      }
      busy(next, true);
      setTimeout(renderSms, 240);
    });
  }

  function renderSms() {
    currentRender = renderSms;
    step = 3;
    progress(3);
    result = result || resolve(answers);
    paintMedia(IMG.desktopLeft);

    if (scrim) {
      var staleMenus = scrim.querySelectorAll("#ar-cc-menu");
      for (var si = 0; si < staleMenus.length; si++) staleMenus[si].remove();
    }

    var parsed = parseStoredPhone(answers.phone);
    phoneCountry = parsed.iso || phoneCountry;
    var c0 = getCountry(phoneCountry);

    paint(
      '<h2 class="ar-h ar-fade ar-fade-2">Get it by text</h2>' +
      '<p class="ar-sub ar-fade ar-fade-3">Add your number and we\'ll text your mystery discount.</p>' +
      '<div class="ar-field ar-fade ar-fade-4">' +
        '<label for="ar-sms">Mobile number</label>' +
        '<div class="ar-phone">' +
          '<div class="ar-phone__dial">' +
            '<button type="button" class="ar-phone__btn" id="ar-cc-btn" aria-haspopup="listbox" aria-expanded="false" aria-label="Country code">' +
              '<span class="ar-phone__flag" id="ar-cc-flag">' + c0.flag + "</span>" +
              '<span class="ar-phone__code" id="ar-cc-code">+' + c0.dial + "</span>" +
              '<span class="ar-phone__chev" aria-hidden="true"></span>' +
            "</button>" +
            '<div class="ar-phone__menu" id="ar-cc-menu" role="listbox" aria-label="Country code"></div>' +
          "</div>" +
          '<input id="ar-sms" class="ar-phone__input" type="tel" inputmode="tel" autocomplete="tel-national" placeholder="Phone number" value="' + esc(parsed.national || "") + '">' +
        "</div>" +
      "</div>" +
      '<p class="ar-err" id="ar-err" role="alert"></p>' +
      '<button type="button" class="ar-btn ar-wide ar-fade ar-fade-5" data-act="next">Text my discount</button>' +
      '<p class="ar-legal ar-fade ar-fade-5">By clicking Text my discount, you agree to receive recurring automated marketing text messages (e.g. cart reminders) from Angel Ruche at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Reply HELP for help and STOP to cancel. View our <a href="' + esc(CFG.termsUrl) + '" target="_blank" rel="noopener">Terms</a> and <a href="' + esc(CFG.privacyUrl) + '" target="_blank" rel="noopener">Privacy Policy</a>.</p>' +
      '<p class="ar-dismiss ar-fade ar-fade-6"><button type="button" class="ar-textlink" data-act="skip">No thanks, just email it to me</button></p>',
      { focusSelector: "#ar-sms" }
    );

    var input = pane.querySelector("#ar-sms");
    var err = pane.querySelector("#ar-err");
    var next = pane.querySelector("[data-act=next]");
    var skip = pane.querySelector("[data-act=skip]");
    var btn = pane.querySelector("#ar-cc-btn");
    var menu = pane.querySelector("#ar-cc-menu");
    var flagEl = pane.querySelector("#ar-cc-flag");
    var codeEl = pane.querySelector("#ar-cc-code");

    function setCountry(iso, closeMenu) {
      var c = getCountry(iso);
      phoneCountry = c.iso;
      flagEl.textContent = c.flag;
      codeEl.textContent = "+" + c.dial;
      var opts = menu.querySelectorAll(".ar-phone__opt");
      for (var i = 0; i < opts.length; i++) {
        opts[i].setAttribute("aria-selected", opts[i].getAttribute("data-iso") === c.iso ? "true" : "false");
      }
      if (closeMenu) openMenu(false);
    }

    function buildMenu() {
      var sorted = COUNTRIES.slice().sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      menu.innerHTML = sorted.map(function (c) {
        return '<button type="button" class="ar-phone__opt" role="option" data-iso="' + c.iso + '" aria-selected="' + (c.iso === phoneCountry ? "true" : "false") + '">' +
          '<span class="ar-phone__flag">' + c.flag + "</span>" +
          '<span class="ar-phone__opt-name">' + c.name + "</span>" +
          '<span class="ar-phone__opt-dial">+' + c.dial + "</span>" +
        "</button>";
      }).join("");
      Array.prototype.forEach.call(menu.querySelectorAll(".ar-phone__opt"), function (opt) {
        opt.addEventListener("click", function () {
          setCountry(opt.getAttribute("data-iso"), true);
          input.focus();
        });
      });
    }

    function placeMenu() {
      var rect = btn.getBoundingClientRect();
      var width = Math.min(280, window.innerWidth * 0.72);
      var left = Math.min(rect.left, window.innerWidth - width - 8);
      left = Math.max(8, left);
      var spaceBelow = window.innerHeight - rect.bottom - 12;
      var spaceAbove = rect.top - 12;
      var maxH = 220;
      if (spaceBelow >= 160 || spaceBelow >= spaceAbove) {
        menu.style.top = Math.round(rect.bottom + 6) + "px";
        menu.style.bottom = "auto";
        menu.style.maxHeight = Math.min(maxH, Math.max(120, spaceBelow)) + "px";
      } else {
        menu.style.bottom = Math.round(window.innerHeight - rect.top + 6) + "px";
        menu.style.top = "auto";
        menu.style.maxHeight = Math.min(maxH, Math.max(120, spaceAbove)) + "px";
      }
      menu.style.left = Math.round(left) + "px";
      menu.style.width = Math.round(width) + "px";
    }

    function openMenu(open) {
      if (open) {
        if (menu.parentNode !== scrim) scrim.appendChild(menu);
        menu.classList.add("ar-open");
        btn.setAttribute("aria-expanded", "true");
        placeMenu();
      } else {
        menu.classList.remove("ar-open");
        btn.setAttribute("aria-expanded", "false");
      }
    }

    buildMenu();

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openMenu(!menu.classList.contains("ar-open"));
    });

    document.addEventListener("click", function onDoc(e) {
      if (!pane.contains(btn)) {
        document.removeEventListener("click", onDoc);
        return;
      }
      if (!btn.contains(e.target) && !menu.contains(e.target)) {
        openMenu(false);
      }
    });

    window.addEventListener("resize", function onResize() {
      if (!pane.contains(btn)) {
        window.removeEventListener("resize", onResize);
        return;
      }
      if (menu.classList.contains("ar-open")) placeMenu();
    });

    function submit(withPhone) {
      if (withPhone) {
        var e164 = toE164(phoneCountry, input.value);
        if (!e164) {
          err.textContent = "Enter a valid " + getCountry(phoneCountry).name + " mobile number.";
          input.focus();
          return;
        }
        answers.phone = e164;
        answers.phoneCountry = phoneCountry;
      } else {
        delete answers.phone;
        delete answers.phoneCountry;
      }

      openMenu(false);
      err.textContent = "";
      submitQuiz({ next: next, label: "Text my discount", lock: [next, skip], err: err, input: input });
    }

    input.addEventListener("keydown", function (e) { if (e.key === "Enter") next.click(); });
    input.addEventListener("input", function () { err.textContent = ""; });
    next.addEventListener("click", function () { submit(true); });
    skip.addEventListener("click", function () { submit(false); });
  }

  function renderSuccess() {
    currentRender = renderSuccess;
    step = 4;
    progress(4);
    result = result || resolve(answers);
    paintMedia(IMG.last);

    paint(
      '<p class="ar-pill ar-fade ar-fade-1">Your mystery discount</p>' +
      '<h2 class="ar-h ar-h--gift ar-fade ar-fade-2">You\'re in</h2>' +
      '<p class="ar-p ar-fade ar-fade-3">' + (answers.phone ? "Check your inbox and texts for your code" : "Check your inbox for your code") + "</p>" +
      '<a class="ar-btn ar-wide ar-fade ar-fade-4" data-act="shop" href="' + esc(result.path) + '">Shop your discount</a>' +
      '<p class="ar-dismiss ar-fade ar-fade-5"><button type="button" class="ar-textlink" data-act="close">Keep browsing</button></p>'
    );

    pane.querySelector("[data-act=shop]").addEventListener("click", function () {
      track("clicked_recommendation", true);
    });
    pane.querySelector("[data-act=close]").addEventListener("click", close);
  }

  function playDecos() {
    if (!modal) return;
    var wrap = modal.querySelector(".ar-decos");
    if (!wrap) return;
    wrap.classList.remove("ar-decos-on");
    void wrap.offsetWidth;
    wrap.classList.add("ar-decos-on");
  }

  // ------------------------------------------------------------------
  // Open / close
  // ------------------------------------------------------------------

  function open() {
    build();
    applyVariant();
    lastFocus = document.activeElement;
    scrim.classList.add("ar-open");
    document.body.classList.add("ar-quiz-on");
    document.body.style.overflow = "hidden";
    playDecos();
    if (!pane.querySelector(".ar-pane__inner")) renderQuestion(0);
    writeStore("sessionStorage", STORE.seen, "1");
    if (!viewed) {
      viewed = true;
      track("viewed");
    }
  }

  function close() {
    if (!scrim) return;
    scrim.classList.remove("ar-open");
    document.body.classList.remove("ar-quiz-on");
    document.body.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function dismissQuiz() {
    closedOut = true;
    writeStore("localStorage", STORE.dismissedAt, String(Date.now()));
    track("dismissed");
    close();
  }

  function reset() {
    answers = {};
    result = null;
    step = 0;
    currentRender = null;
    anonId = newAnonId();
    viewed = false;
    submitted = false;
    closedOut = false;
    if (pane) pane.innerHTML = "";
    if (media) media.removeAttribute("data-ready");
    if (scrim && scrim.classList.contains("ar-open")) renderQuestion(0);
  }

  function setVariant(v) {
    CFG.forceVariant = v === "desktop" || v === "mobile" ? v : "auto";
    applyVariant();
  }

  // Leaving mid-quiz: an email already typed is still a lead, so it is
  // completed (email only - SMS consent was never given); anything earlier is
  // recorded as abandoned.
  window.addEventListener("pagehide", function () {
    if (!viewed || submitted || closedOut) return;
    closedOut = true;
    if (step === 3 && answers.email) {
      delete answers.phone;
      try { complete(true).catch(function () {}); } catch (e) {}
      writeStore("localStorage", STORE.submitted, "1");
      return;
    }
    track("abandoned", true);
  });

  window.AngelRucheQuiz = {
    open: open,
    close: close,
    reset: reset,
    setVariant: setVariant,
    getVariant: function () { return variant; }
  };

  // ------------------------------------------------------------------
  // When to show it
  // ------------------------------------------------------------------

  function suppressed() {
    if (CFG.suppress) return true;
    if (readStore("localStorage", STORE.submitted) === "1") return true;
    var dismissedAt = Number(readStore("localStorage", STORE.dismissedAt));
    if (dismissedAt && Date.now() - dismissedAt < CFG.dismissDays * 864e5) return true;
    if (readStore("sessionStorage", STORE.seen) === "1") return true;
    // Arrived from a Klaviyo email or text: already a subscriber.
    if (params.has("_kx") || /^(email|sms)$/i.test(params.get("utm_medium") || "")) return true;
    if (/^\/(cart|account|checkouts?|orders)(\/|$)/.test(location.pathname)) return true;
    return false;
  }

  /** Klaviyo's own cookie, for when klaviyo.js is blocked or slow. An anonymous visitor carries only a `cid`. */
  function klaviyoCookieIdentified() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!m) return false;
      var data = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(data && (data.$exchange_id || data.$email || data.$phone_number || data.$id));
    } catch (e) {
      return false;
    }
  }

  /**
   * True when this browser is already tied to a Klaviyo profile (an earlier
   * signup, or a click from a Klaviyo message on a past visit). klaviyo.js
   * queues isIdentified() until it loads, so it is capped rather than awaited.
   */
  function klaviyoIdentified() {
    if (klaviyoCookieIdentified()) return Promise.resolve(true);
    return new Promise(function (resolve) {
      var timer = setTimeout(function () { resolve(false); }, 1500);
      function done(value) {
        clearTimeout(timer);
        resolve(value === true);
      }
      try {
        if (!window.klaviyo || typeof window.klaviyo.isIdentified !== "function") return done(false);
        Promise.resolve(window.klaviyo.isIdentified()).then(done, function () { done(false); });
      } catch (e) {
        done(false);
      }
    });
  }

  function arm() {
    var fired = false;
    var startedAt = Date.now();

    function fire() {
      if (fired) return;
      fired = true;
      clearTimeout(timer);
      document.removeEventListener("mouseout", onExit);
      window.removeEventListener("scroll", onScroll);
      // Asked at trigger time, when klaviyo.js has almost always loaded.
      klaviyoIdentified().then(function (known) {
        if (known) {
          writeStore("sessionStorage", STORE.seen, "1");
          return;
        }
        open();
      });
    }

    function onExit(e) {
      if (e.relatedTarget || e.clientY > 0) return;
      if (Date.now() - startedAt < CFG.exitIntentAfterMs) return;
      fire();
    }

    function onScroll() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= CFG.mobileScrollDepth) fire();
    }

    var timer = setTimeout(fire, CFG.delayMs);
    if (activeVariant() === "desktop") document.addEventListener("mouseout", onExit);
    else window.addEventListener("scroll", onScroll, { passive: true });
  }

  function boot() {
    if (!CFG.endpoint) {
      if (window.console) console.warn("[ar-quiz] ARQuizConfig.endpoint is missing; quiz disabled.");
      return;
    }
    if (params.get("ar_quiz") === "1") {
      open();
      return;
    }
    if (!suppressed()) arm();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
